import { Injectable } from "@angular/core";
import { EntityCollectionServiceElementsFactory } from "@ngrx/data";
import { PolarisEntityCollectionServiceBase } from "../shared/services/polaris-entity-collection-service-base.service";
import { ListingHistory } from "./listing-history";

@Injectable({
	providedIn: "root",
})
export class ListingHistoryService extends PolarisEntityCollectionServiceBase<ListingHistory> {
	constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
		super("ListingHistory", serviceElementsFactory);
	}
}
